import React, { useState } from "react";
import { auth } from "../firebaseConfig";
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export function ResetPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const actionCodeSettings = {
        url: "http://localhost:3000/login", // Redireciona após redefinição de senha
        handleCodeInApp: true, // Garante que o Firebase lida com o código no app
      };

      await sendPasswordResetEmail(auth, email, actionCodeSettings);
      setMessage("Se este e-mail estiver cadastrado, você receberá um link para redefinir sua senha.");

      // Redirecionar para Home após 5 segundos
      setTimeout(() => navigate("/"), 5000);
    } catch (err) {
      setError("Erro ao enviar e-mail. Verifique se o endereço digitado está correto.");
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white shadow p-6 rounded">
      <h1 className="text-2xl font-bold mb-4">Redefinir Senha</h1>
      {message && <p className="text-green-500">{message}</p>}
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleResetPassword}>
        <div className="mb-4">
          <label className="block mb-2">Email</label>
          <input
            type="email"
            className="w-full p-2 border rounded"
            placeholder="Digite seu email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <button className="w-full bg-blue-600 text-white p-2 rounded">
          Enviar Link de Redefinição
        </button>
      </form>
    </div>
  );
}
